module.exports = __webpack_public_path__ + "img/bruna.nl.861f69c.png";